// extracted by mini-css-extract-plugin
export default {"epidStatus":"EpidStatus_epidStatus__XS9vt","tableContainer":"EpidStatus_tableContainer__3gchj"};